
interface Paycode{
    paycode_id: number;
    name: string;
}

interface Combination {
    paycode_id: number;
    paycode_combination_id: number;
    start_date: string;
    end_date: string;
}

interface PaycodeCombination {
    id: number;
    name: string;
    end_date: string;
    start_date: string;
    enable:boolean;
    paycodes: Paycode[];
    combinations: Combination[];
}

export class PaycodesCombinationRepository {
    private httpService: IHttpService
    constructor(instance: IHttpService) {
        this.httpService = instance;
    }

    async getAll(params?: URLSearchParams): Promise<PaycodeCombination[]> {
        try {
            const response = await this.httpService.get<TKResponse<PaycodeCombination[]>>('/paycodes_combinations', { params });
            const data = response.data.map((combination: PaycodeCombination) => ({
                ...combination,
                id: combination.paycode_combination_id
            }));
            return data.sort((a, b) => ((a as any).name ?? '').localeCompare((b as any).name ?? ''));
        } catch (error) {
            console.error('Error al obtener los paycodes combinations:', error);
            throw error;
        }
    }
    async create(data: PaycodeCombinationCreate): Promise<{data: PaycodeCombination, status: number}> {
        try {
            const response = await this.httpService.post<PaycodeCombination, PaycodeCombinationCreate>('/paycodes_combinations', { data });
            return { data: response, status: 200 };
        } catch (error) {
            console.error("Error creating paycode combination:", error);
            throw error;
        }
    }
    async update(id: number, data: PaycodeCombinationUpdate): Promise<{data: PaycodeCombination, status: number}> {
        try {
            const response = await this.httpService.patch<PaycodeCombination, PaycodeCombinationUpdate>(`/paycodes_combinations/${id}`, { data });
            return { data: response, status: 200 };
        } catch (error) {
            console.error("Error updating paycode combination:", error);
            throw error;
        }
    }
    async delete(id: number): Promise<void> {
        try {
            await this.httpService.delete(`/paycodes_combinations/${id}`);
        } catch (error) {
            console.error("Error deleting paycode combination:", error);
            throw error;
        }
    }

}